/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `CASH_SPOT` - Cash (spot)
 * `LOWER_OF_TWO_AT_FIXING` - Lower of two at fixing
 * `OTHER` - Other
 * `3_MONTHS_AVG` - 3 months avg
 */
export type PriceAsIndexPercentageFixedOnEnum =
  (typeof PriceAsIndexPercentageFixedOnEnum)[keyof typeof PriceAsIndexPercentageFixedOnEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAsIndexPercentageFixedOnEnum = {
  CASH_SPOT: 'CASH_SPOT',
  LOWER_OF_TWO_AT_FIXING: 'LOWER_OF_TWO_AT_FIXING',
  OTHER: 'OTHER',
  '3_MONTHS_AVG': '3_MONTHS_AVG',
} as const;
